<template>
    <div class="flex flex-col bg-gray-academy-900">
        <h1 class="h-auto md:h-16 w-5/6 flex flex-col md:flex-row md:justify-between items-center
        justify-start uppercase text-white mx-auto leading-8 my-4 md:my-0">
            <h2 class="hover:text-grey-academy-200">
                <router-link to="/about">
                    {{ $t('app.about') }} </router-link>
            </h2>
            <h2 class="hover:text-grey-academy-200">
                <router-link to="/contacts">
                    {{ $t('home.contacts') }}
                </router-link>
            </h2>
        </h1>
        <div class="flex flex-col md:flex-row items-center h-auto md:h-8 text-xs
          bg-background-footer text-white w-screen pb-2 md:pb-0">
          <div class="flex flex-col md:flex-row w-5/6 mx-auto justify-between">
            <div class="flex justify-between md:justify-start my-2 md:my-0">
              <h2>
                  {{ year }} © E-Cademy Music
              </h2>
              <h2 class="pl-6">
                  Privacy Policy
              </h2>
            </div>
            <div>Icons made by <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),

    year() {
      const now = dayjs();
      return now.year();
    },
  },
};
</script>
